/* @flow */


import openrtbbase from './openrtbbase';
import { buildUrl } from '../utils/coreutils';

/**
 * @module bidders/conversant
 * @requires module:logger
 * @requires module:promiseutils
 */
/**
 * @global
 * @description extends {@link hbConfig}
 * @property {string} bidUrl - Bid URL
 */

/**
 * @description Implements functionality for conversant header bidding
 * @augments _bidbase
 * @requires module:utils
 * @requires module:jsonp
 */
class _conversant extends openrtbbase {
  _syncUrls: Array<syncUrl>;

  constructor(name: string) {
    super(name);
    this._mandatoryConfigs = ['bidUrl'];
    // Conversant: align with Prebid (no sua) by using OpenRTB 2.5 behavior
    this._openrtbVersion = 2.5;
    this._reqContentType = 'text/plain';
    this._reqWithCredentials = true;
    this._reqWithOpenRTBVersion = false;
    this._syncUrls = [];
  }

  _processResponse(
    posList: Array<string>,
    response: RTBBidResponse,
    ret: hbPartnerData
  ): hbPartnerData {
    // Call base implementation for bid processing
    const result = super._processResponse(posList, response, ret);

    // Extract user sync URLs from response.ext
    this._extractUserSyncUrls(response);

    return result;
  }

  _extractUserSyncUrls(response: RTBBidResponse): void {
    this._syncUrls = [];

    if (!response || !response.ext) {
      return;
    }

    const { ext } = response;

    // Extract iframe syncs (fsyncs)
    if (Array.isArray(ext.fsyncs)) {
      ext.fsyncs.forEach(url => {
        if (typeof url === 'string' && url.length > 0) {
          this._syncUrls.push({ url, type: 'iframe' });
        }
      });
    }

    // Extract image syncs (psyncs)
    if (Array.isArray(ext.psyncs)) {
      ext.psyncs.forEach(url => {
        if (typeof url === 'string' && url.length > 0) {
          this._syncUrls.push({ url, type: 'image' });
        }
      });
    }
  }

  _getUserSync(): Array<syncObj> {
    const name = this.getName();
    const privacy = this._getPrivacyString();

    // Build privacy params once (same for all URLs)
    const params = {};
    if (privacy.us_privacy) {
      // eslint-disable-next-line camelcase
      params.us_privacy = privacy.us_privacy;
    }

    return this._syncUrls.map(({ url, type }) => {
      // Append CCPA privacy parameter using buildUrl
      const finalUrl = buildUrl(url, params);

      return { name, type, url: finalUrl };
    });
  }

  _getSiteId(posList?: Array<string>): string | void {
    const list = Array.isArray(posList) ? posList : [];
    const firstPos = list.length ? list[0] : '';
    const siteId =
      firstPos &&
      this._config &&
      this._config.posTokenMap &&
      this._config.posTokenMap[firstPos] &&
      this._config.posTokenMap[firstPos].id;
    return siteId || undefined;
  }
}

const conversant: _conversant = new _conversant('conversant');
export default conversant;
